import React, { ReactElement } from "react";

function ButtonBasic(
  props: Readonly<{
    children: ReactElement | string;
    onClick: any;
  }>
) {
  return (
    <button
      className={
        "  rounded-md pr-[8px] pl-[8px]  pt-[8px] pb-[8px] hover:bg-lightbg-150 "
      }
      onClick={props.onClick}
    >
      {props.children}
    </button>
  );
}

export default ButtonBasic;
